<template>
  <div class="announce-detail-wrap">
    <div class="spin-wrap" v-if="loading">
      <a-spin class="spin-item" :spinning="loading"/>
    </div>
    <div class="empty-wrap" v-else-if="total === 0">
      <Empty></Empty>
    </div>
    <a-row v-else class="ant-row-wrap" v-for="(item, index) in detailInfos" :key="index" :gutter="[16, 16]">
      <a-col v-for="colItem in item" :key="colItem.id" :instance="colItem" :span="colItem.span" >
        <AnnounceCard :instance="colItem" @click.native="toDetail(colItem.id)"></AnnounceCard>
      </a-col>
    </a-row>
    <Pagination :total="total" :pageSize="6" @pageChange="handleChange"></Pagination>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import AnnounceCard from './components/announcementCard.vue'
import { getMoreTransInfo } from '@/api/tradingInfos.js'
import Empty from '@/components/common/Empty/index'
import mixinsBackStack from '@/views/backstageSupport/mixins'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      loading: false,
      isEmpty: false,
      detailInfos: null,
      total: 0,
      params: {
        pageSize: 6,
        pageNum: 1
      }
    }
  },
  components: {
    AnnounceCard,
    Empty,
    Pagination
  },
  created() {
    this.initDefaultValue()
  },
  methods: {
    async initDefaultValue() {
      try {
        this.loading = true
        const { rows, total } = await getMoreTransInfo(this.params)
      this.handlerDateFormat(rows)
        this.detailInfos = rows
        this.isEmpty = total === 0
        this.total = total
        this.initSetting()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
      
    },
    initSetting() {
      this.detailInfos = this.detailInfos.reduce((pre, cur, index) => {
        const item = {
          ...cur,
          span: 8
        }
        const gather = Math.floor(index / 3)
        if (index % 3 === 0) {
          pre.push([item])
        } else {
          pre[gather].push(item)
        }
        return pre
      }, [])
    },
    // 切换页面
    handleChange(e) {
      // console.log(e)
      this.params.pageNum = e
      this.initDefaultValue()
    },
    toDetail(id) {
      this.$router.push({ name: 'detailAnnouncement', query: { id } })
    }
  }
}
</script>
